import * as React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {IconButton} from '@openfin/desktop-ui';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';
import * as SettingsIcon from '../../../assets/Settings.svg';
import * as MinimizeIcon from '../../../assets/Minus.svg';
import {HistoryContext} from '../../contexts/HistoryContext';
import {ROUTES} from '../../../components/Router/consts';
import {RootState} from '../../../store/State';
import {SetLaunchBarWindowState} from '../../../store/partials/LaunchBar';
import {LaunchBarSize, WindowState} from '../../utils/constants';
import {isOmnibar} from '../../../utils/processHelpers';

import * as Styles from './BookendControls.module.scss';

interface Props {
    currentSize: LaunchBarSize;
    onMinimize: () => void;
}

const BookendControlsComponent: React.FC<Props> = (props) => {
    const {onMinimize} = props;
    const history = React.useContext(HistoryContext);
    return (
        <div className={Styles['bookend']}>
            <IconButton className={ClassNameBuilder.join(Styles, 'icon', 'minimize')} image={MinimizeIcon} title="Minimize" onClick={onMinimize} />
            {!isOmnibar() && <IconButton
                className={ClassNameBuilder.join(Styles, 'icon', 'settings')}
                image={SettingsIcon}
                title="Settings"
                onClick={() => history.push(ROUTES.SETTINGS_PANEL)}
            />}
        </div>
    );
};

const mapState = (state: RootState) => ({
    currentSize: state.launchBar.size
});

const mapDispatch = (dispatch: Dispatch) => ({
    onMinimize: () => dispatch(new SetLaunchBarWindowState(WindowState.MINIMIZED))
});

export const BookendControls = connect(mapState, mapDispatch)(BookendControlsComponent);
